import { render, staticRenderFns } from "./Ads.vue?vue&type=template&id=e0134508&scoped=true"
import script from "./Ads.vue?vue&type=script&lang=js"
export * from "./Ads.vue?vue&type=script&lang=js"
import style0 from "./Ads.vue?vue&type=style&index=0&id=e0134508&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0134508",
  null
  
)

export default component.exports